import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'id',
        label: i18n.t('attributes.id'),
        _style: 'width:11%'
    },
    {
        key: 'subject',
        label: i18n.t('ticket.subject'),
        _style: 'width:25%'
    },
    {
        key: 'status',
        label: i18n.t('ticket.status'),
    },
    {
        key: 'category',
        label: i18n.t('ticket.department'),
    },
    {
        key: 'createdFor',
        label: i18n.t('ticket.created_for'),
        _style: 'width:13%',
        policies: {
            ticket: ['create_any_or_group']
        }
    },
    {
        key: 'createdBy',
        label: i18n.t('attributes.created_by'),
        _style: 'width:13%',
        policies: {
            ticket: ['create_any_or_group']
        }
    },
    {
        key: 'responsible',
        label: i18n.t('ticket.responsible'),
        _style: 'width:20%'
    },
    {
        key: 'lastUpdate',
        label: i18n.t('ticket.last_update'),
        _style: 'width:13%'
    },
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
]